module.exports = __webpack_public_path__ + "static/media/02_avatar_female.8722823a.png";